import { render } from "./SymbolCheckbox.vue?vue&type=template&id=8710a04e"
import script from "./SymbolCheckbox.vue?vue&type=script&lang=js"
export * from "./SymbolCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__